
import "./footer.css";

/* navegação */
import { Link } from "react-router-dom";

/* autenticação */
import { auth } from "../../services/firebaseConnection";
import { signOut } from "firebase/auth";

/* redux */
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/user/slice";
import { deleteAgent } from "../../redux/agent/slice.js";

/* funções auxiliares */
import { registerLog } from "../../services/functions/functions.ts";


export default function Footer({access}) {

    const dispatch = useDispatch();

    const { user } = useSelector((rootReducer) => rootReducer.user);

    async function logout() {

        await signOut(auth);

        registerLog(user.id, "/logout");

        dispatch(logoutUser());
        dispatch(deleteAgent());

        sessionStorage.removeItem('id');
        sessionStorage.removeItem('empresa');
        sessionStorage.removeItem('nome');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('acesso');

        sessionStorage.removeItem('agente_id');
        sessionStorage.removeItem('agente');
        sessionStorage.removeItem('plano');

    }


    return(
        <div className="footer">
            <div className="footer_content">
                <div className="footer_contato">
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Quer saber sobre nós?</span>
                        <span className="footer_contato_box_item">Quem Somos</span>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Conheça nossa:</span>
                        <span className="footer_contato_box_item">Política de Privacidade e Termos de Uso</span>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Contato:</span>
                        <span className="footer_contato_box_item">atendimento@winners-ia.com</span>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Dúvidas???</span>
                        <span className="footer_contato_box_item">Fale com o nosso agente aqui</span>
                    </div>
                </div>
                <span className="footer_line"></span>
                <div className="footer_links">
                    { access === 0 ? (
                    <>
                    <div className="footer_links_box">
                        <span className="footer_links_title">Links:</span>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/" className="footer_links_item">Página Inicial</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/howitworks" className="footer_links_item">Como Funciona</Link>
                        <Link to="/subscription" className="footer_links_item">Planos</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/login" className="footer_links_item">Entrar</Link>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="footer_links_box">
                        <span className="footer_links_title">Links:</span>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/panel" className="footer_links_item">Painel do Cliente</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/agent" className="footer_links_item">Agentes</Link>
                        <Link to="" className="footer_links_item">Perfomance</Link>
                        <Link to="" className="footer_links_item">Pagamentos</Link>
                        <Link to="" className="footer_links_item">Configurações</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/login" className="footer_links_item" onClick={ logout }>Sair</Link>
                    </div>
                    </>
                    )}
                </div>
            </div>
            <div className="footer_infos">
                <span className="footer_infos_direitos">&copy;&nbsp;Todos os direitos reservados a winners-ai</span>
                <span className="footer_infos_cnpj">Cnpj 10.214.659/0001-02</span>
                <span className="footer_infos_versao">Plataforma v2.43-251202</span>
            </div>
        </div>
    )
}